import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import api from "../lib/api";
import { relTime } from "../lib/format";
import TopBar from "../components/TopBar";
import EmptyState from "../components/EmptyState";

export default function QaCenterPage() {
  const [missions, setMissions] = useState([]);
  const [runsByMission, setRunsByMission] = useState({});

  useEffect(() => {
    (async () => {
      const { data: ms } = await api.get("/missions");
      setMissions(ms);
      const runs = {};
      await Promise.all(
        ms.slice(0, 20).map(async (m) => {
          const { data } = await api.get(`/missions/${m.id}/qa_runs`);
          if (data.length) runs[m.id] = data[0];
        })
      );
      setRunsByMission(runs);
    })();
  }, []);

  const withRuns = missions.filter((m) => runsByMission[m.id]);

  return (
    <>
      <TopBar title="QA Center" subtitle="Independent evidence before release." />
      <div className="panel">
        <div className="panel-head">
          <div><h2>Latest QA verdicts</h2><p>Most recent QA run per mission.</p></div>
          <span className="pill dim">{withRuns.length}</span>
        </div>
        <div className="panel-body">
          {withRuns.length === 0 ? (
            <EmptyState title="No QA runs yet." subtitle="QA orchestration starts in Phase 3." icon={ShieldCheck} />
          ) : (
            withRuns.map((m) => {
              const r = runsByMission[m.id];
              return (
                <div className="wide-row" key={m.id}>
                  <div>
                    <b>{m.title}</b>
                    <p>{r.verdict} · {r.recommendations.slice(0, 2).join(" · ")}</p>
                  </div>
                  <small className="hint">{relTime(r.created_at)}</small>
                </div>
              );
            })
          )}
        </div>
      </div>
    </>
  );
}
